import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=36df707a&scoped=true&"
import script from "./AppBar.vue?vue&type=script&lang=ts&"
export * from "./AppBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=36df707a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_tmekgxb4kz2cwcpbztklgmtyca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df707a",
  null
  
)

export default component.exports